import i18next from 'i18next';

import {TransactionStatus} from 'web-app/util/graphql/api-types';

export const addInvoiceDialogTexts = (notify: boolean | undefined | null) => {
    return {
        title: i18next.t(
            notify
                ? 'childProfile.accountBalance.sendInvoiceConfirmationTitle'
                : 'childProfile.accountBalance.createInvoiceConfirmationTitle',
        ),
        description: i18next.t(
            notify
                ? 'childProfile.accountBalance.sendInvoiceConfirmationDescription'
                : 'childProfile.accountBalance.createInvoiceConfirmationDescription',
        ),
        okText: i18next.t(notify ? 'childProfile.accountBalance.sendInvoiceButtonTitle' : 'create'),
    };
};

export const getTranslatedTransactionStatus = (status?: TransactionStatus) => {
    switch (status) {
        case TransactionStatus.COMPLETED:
            return i18next.t('settings.payments.transactionStatus.COMPLETED');
        case TransactionStatus.DISPUTED:
            return i18next.t('settings.payments.transactionStatus.DISPUTED');
        case TransactionStatus.FAILED:
            return i18next.t('settings.payments.transactionStatus.FAILED');
        case TransactionStatus.PENDING:
            return i18next.t('settings.payments.transactionStatus.PENDING');
        case TransactionStatus.PROCESSING:
            return i18next.t('settings.payments.transactionStatus.PROCESSING');
        case TransactionStatus.REFUNDED:
            return i18next.t('settings.payments.transactionStatus.REFUNDED');
        case TransactionStatus.REQUIRES_VALIDATION:
            return i18next.t('settings.payments.transactionStatus.REQUIRES_VALIDATION');
        default:
            return '';
    }
};
